import { Box, MenuItem, SelectChangeEvent, Typography, useTheme } from '@mui/material';
import { StatusFilter } from 'app/shared/model/enumerations/status-filter.model';
import React from 'react';
import { translate } from 'react-jhipster';
import { SelectDefault } from '../select-default/SelectDefault';

interface StatusFilterProps {
  setStatus: (status: StatusFilter) => void;
  status: StatusFilter | string;
}

const StatusFilterSelect: React.FC<StatusFilterProps> = ({ setStatus, status }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        [theme.breakpoints.up('sm')]: {
          maxWidth: '250px',
        },
      }}
    >
      <Typography textAlign="left" color="text.primary" fontWeight="600" fontSize="16px">
        Status
      </Typography>
      <SelectDefault value={status} onChange={(event: SelectChangeEvent) => setStatus(event.target.value as StatusFilter)}>
        {Object.values(StatusFilter).map(statusValue => (
          <MenuItem key={statusValue} value={statusValue}>
            {translate(`fleetSenseApp.StatusFilter.${statusValue}`)}
          </MenuItem>
        ))}
      </SelectDefault>
    </Box>
  );
};

export default StatusFilterSelect;
